import { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router'
import { clearAxiosClientHeader, setAxiosClientHeader } from '../../helpers/AuthorizationHelpers'
import { getAdminUserClients } from '../../http'
import { Queries } from '../../queries'
import { IClient, IClientMinimal } from '../../types/data-types'
import { Spinner } from '../Common/Spinner'

interface IUserClientsContext {
  admin?: boolean
  setAdmin?: (admin: boolean) => any
  selectedClient?: IClient
  clients: IClient[]
  partnerClients: IClientMinimal[]
  setClient: (client: IClientMinimal) => any
  pushRoute: (route: string) => any
}

export const UserClientsContext = createContext<IUserClientsContext>(null)

function getClientSearchParams(client) {
  return new URLSearchParams({ client }).toString()
}

export const UserClientsContextProvider = ({ children }) => {
  const [admin, setAdmin] = useState(true)
  const onClientsChange = (clients: IClient[]) => {
    if (!clients?.length) return setUserClient(null)
    const clientId = parseInt(new URLSearchParams(history.location.search).get('client'))
    if (!clientId) return setUserClient(clients[0])

    setUserClient(clients.find(c => c.clientId === clientId) ?? clients[0])
  }
  const history = useHistory()
  const { data: userClients, isLoading } = useQuery([Queries.USER_CLIENTS, admin], () => getAdminUserClients(admin), {
    onSuccess: onClientsChange,
  })

  useEffect(() => {
    return clearAxiosClientHeader
  }, [])

  const [selectedClient, setClient] = useState<IClient>(userClients ? userClients[0] : null)
  useEffect(() => {
    if (userClients?.length > 0 && !selectedClient) setClient(userClients[0])
  }, [userClients])

  const setUserClient = (client: IClient) => {
    setAxiosClientHeader(client?.clientId)
    setClient(client)

    if (!client) return
    const search = getClientSearchParams(client.clientId)
    history.push({ pathname: history.location.pathname, search })
  }

  const pushRoute = (pathname: string) => {
    const search = getClientSearchParams(selectedClient?.clientId)

    return history.push({ pathname, search })
  }

  const providerValue = {
    selectedClient,
    setClient: setUserClient,
    clients: userClients?.filter(c => !c.isPartner) || [],
    partnerClients: userClients || [],
    admin,
    setAdmin,
    pushRoute,
  }

  if (selectedClient) setAxiosClientHeader(selectedClient.clientId)

  return (
    <UserClientsContext.Provider value={providerValue}>
      {isLoading ? <Spinner /> : children}
    </UserClientsContext.Provider>
  )
}
